export default function (images) {
  const checkImage = path =>
    new Promise(resolve => {
      if (path.complete) resolve({ path, status: 'ok' });
      path.onload = () => resolve({ path, status: 'ok' });
      path.onerror = () => resolve({ path, status: 'error' });
    });
  return Promise.all([].slice.call(images).map(checkImage));
}
